import ApiClient from '@/services/apiClient';

export default class Member {
  id = 0;
  email;
  name;
  first_name;
  company_name;
  picture;
  mobile_phone_number;
  alert;
  group_admin;
  can_create;
  send_change_password_link;
  children_facility_filter;
  filtered_facilities;

  constructor() {
    this.id = 0;
    this.email = "";
    this.name = "";
    this.first_name = "";
    this.company_name = "";
    this.mobile_phone_number = "";
    this.alert = false;
    this.group_admin = false;
    this.can_create = false;
    this.send_change_password_link = true;
    this.children_facility_filter = false;
    this.filtered_facilities = [];
  }

  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Member();
      obj.id = ApiClient.convertToType(data['id'], 'Integer');
      obj.email = ApiClient.convertToType(data['email'], 'String');
      obj.name = ApiClient.convertToType(data['name'], 'String');
      obj.first_name = ApiClient.convertToType(data['first_name'], 'String');
      obj.company_name = ApiClient.convertToType(data['company_name'], 'String');
      obj.picture = ApiClient.convertToType(data['picture'], 'String');
      obj.mobile_phone_number = ApiClient.convertToType(data['mobile_phone_number'], 'String');
      obj.alert = ApiClient.convertToType(data['alert'], 'Boolean');
      obj.group_admin = ApiClient.convertToType(data['group_admin'], 'Boolean');
      obj.can_create = ApiClient.convertToType(data['can_create'], 'Boolean');
      obj.children_facility_filter = ApiClient.convertToType(data['children_facility_filter'], 'Boolean');
      obj.filtered_facilities = ApiClient.convertToType(data['filtered_facilities'], ['Integer'])?? [];
      console.log("filtered_facilities", obj.filtered_facilities, data['filtered_facilities'], ApiClient.convertToType(data['filtered_facilities'], ['Integer']));
      obj.send_change_password_link = false;
    }
    return obj;
  }

  toJSON() {
    const json = {
      email: this.email,
      mobile_phone_number: this.mobile_phone_number,
      name: this.name,
      company_name: this.company_name,
      first_name: this.first_name,
      alert: this.alert,
      group_admin: this.group_admin,
      can_create: this.can_create,
      send_change_password_link: this.send_change_password_link,
      children_facility_filter: this.children_facility_filter,
      filtered_facilities: this.filtered_facilities,
    };

    if (this.picture != null && !this.picture.startsWith("http")) {
      if (this.picture.length === 0) {
        json.picture = "";
      } else {
        json.picture = this.picture.split(',')[1];
      }
    }

    return json;
  }

  get initials() {
    return `${this.first_name.substring(0, 1).toUpperCase()}${this.name.substring(0, 1).toUpperCase()}`;
  }

  get full_name() {
    return `${this.first_name} ${this.name}`;
  }

  get full_access() {
    return !this.children_facility_filter;
  }

  set full_access(value) {
    this.children_facility_filter = !value;
  }
}
